import { render, staticRenderFns } from "./PackageModule.html?vue&type=template&id=382bd1ff&scoped=true&"
import script from "./PackageModule.vue?vue&type=script&lang=js&"
export * from "./PackageModule.vue?vue&type=script&lang=js&"
import style0 from "./PackageModule.vue?vue&type=style&index=0&id=382bd1ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382bd1ff",
  null
  
)

export default component.exports